import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from 'components/Text';
import Box from 'components/Box';
import Flex from 'components/Flex';
import TextInput from 'components/TextInput';
import FormField from 'components/FormField';
var CompletionTimeField = function CompletionTimeField(_ref) {
  var completionTime = _ref.completionTime,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FormField, {
    label: t('form_completion_time'),
    horizontal: true
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, {
    shrink: true,
    basis: 50 + (completionTime.toString().length - 1) * 10,
    mr: "xs"
  }, /*#__PURE__*/React.createElement(TextInput, {
    stealthy: true,
    type: "number",
    value: completionTime,
    placeholder: "0",
    min: "0",
    onChange: onChange,
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement(Text, null, t('minute_count', {
    count: completionTime
  }))));
};
export default CompletionTimeField;